import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { ManageMembershipActions } from "./index";
import {
	FETCH_MEMBERSHIP_DETAILS_FAILURE,
	FETCH_MEMBERSHIP_DETAILS_PROGRESS,
	FETCH_MEMBERSHIP_DETAILS_SUCCESS,
} from "./manageMembership.action";
import { initialManageMembershipState } from "./manageMembership.state";

export const manageMembershipReducer = (
	state: IStoreState["manageMembership"] = initialManageMembershipState,
	action: ManageMembershipActions
) => {
	switch (action.type) {
		case FETCH_MEMBERSHIP_DETAILS_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.loading = true;
				draftState.error = null;
			});
			return newState;
		}
		case FETCH_MEMBERSHIP_DETAILS_SUCCESS: {
			const newState = produce(state, (draftState) => {
				draftState.loading = false;
				draftState.membershipDetails = action.payload;
			});
			return newState;
		}
		case FETCH_MEMBERSHIP_DETAILS_FAILURE: {
			const newState = produce(state, (draftState) => {
				draftState.loading = false;
				draftState.error = action.payload;
			});
			return newState;
		}
		default:
			return state;
	}
};
